import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { handleError } from "../../../../utils/ErrorHandler";

const initialState = {
  availableFranchiseSlots: [],
  isFetchingSlots: false,
  isAssigningSlots: false,
  isFetchingAvailableSlots: false,
  availableSlots: [],

};


// Create slot

// Read slots


// Get available slots franchise

export const getFranchiseAvailableSlots = createAsyncThunk(
  "slots/getFranchiseAvailableSlots",
  async () => {
    try {
      const { data } = await axios.get(`crm-task/?query=all`);
      return data;
    } catch (error) {
      console.error("Error fetching slot data:", error.message);
      throw error;
    }
  }
);

//Get slots by franchise id 

export const getSlotsByFranchiseId = createAsyncThunk(
  "slot/getSlotsByFranchiseId",
  async (franchiseId) => {
    try {
      const { data } = await axios.get(`slots?query=all&franchiseId=${franchiseId}`);
      return data;
    } catch (error) {
      console.error("Error fetching tasks:", error.message);
      throw error;
    }
  }
);



// Update slot 
export const updateSlots = createAsyncThunk(
  "slot/updateSlots",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`slots`, payload);
      toast.success("Slots assigned successfully!");
      return data;
    } catch (error) {
      const errorMessage = handleError(error, "Failed to assign slots");
      return rejectWithValue(errorMessage);
    }
  }
);
// Delete slot
export const deleteSlotsByGameId = createAsyncThunk(
  "slot/deleteSlotsByGameId",
  async ({gameId,franchiseId}, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`slots?gameId=${gameId}&franchiseId=${franchiseId}`);
      toast.success("Slots deleted successfully!");
      return data;
    } catch (error) {
      const errorMessage = handleError(error, "Failed to assign slots");
      return rejectWithValue(errorMessage);
    }
  }
);
// Assign slot

export const createSlots = createAsyncThunk(
  "slot/createSlots",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`slots`, payload);
      toast.success("Slots assigned successfully!");
      return data;
    } catch (error) {
      const errorMessage = handleError(error, "Failed to assign slots");
      return rejectWithValue(errorMessage);
    }
  }
);

// Get Available slots date wise
export const getAvailableSlots = createAsyncThunk(
	"slot/getAvailableSlots",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`slots/filter`, payload);
      return data;
    } catch (error) {
      const errorMessage = handleError(error, "Failed to get available slots");
      return rejectWithValue(errorMessage);
    }
  }
);



const slotSlice = createSlice({
  name: "slot",
  initialState,
  reducers: {
    clearSlot: (state) => {
      state.slot = null;
    },
  },
  extraReducers: (builder) => {


    // getFranchiseAvailableSlots
    builder.addCase(getFranchiseAvailableSlots.pending, (state) => {
      state.isFetchingSlots = true;
      state.error = "";
    });
    builder.addCase(getFranchiseAvailableSlots.fulfilled, (state, action) => {
      state.isFetchingSlots = false;
      state.availableFranchiseSlots = state.availableFranchiseSlots.filter(
        (slot) => slot.id !== action.meta.arg
      );
    });
    builder.addCase(getFranchiseAvailableSlots.rejected, (state, action) => {
      state.isFetchingSlots = false;
      state.error = action.payload;
    });
    // createSlots
    builder.addCase(createSlots.pending, (state) => {
      state.isAssigningSlots = true;
      state.error = "";
    });
    builder.addCase(createSlots.fulfilled, (state, action) => {
      state.isAssigningSlots = false;
    });
    builder.addCase(createSlots.rejected, (state, action) => {
      state.isAssigningSlots = false;
      state.error = action.payload;
    });
    // updateSlots
    builder.addCase(updateSlots.pending, (state) => {
      state.isAssigningSlots = true;
      state.error = "";
    });
    builder.addCase(updateSlots.fulfilled, (state, action) => {
      state.isAssigningSlots = false;
    });
    builder.addCase(updateSlots.rejected, (state, action) => {
      state.isAssigningSlots = false;
      state.error = action.payload;
    });
    // getSlotsByFranchiseId
    builder.addCase(getSlotsByFranchiseId.pending, (state) => {
      state.isFetchingSlots = true;
      state.error = "";
    });
    builder.addCase(getSlotsByFranchiseId.fulfilled, (state, action) => {
      state.isFetchingSlots = false;
    });
    builder.addCase(getSlotsByFranchiseId.rejected, (state, action) => {
      state.isFetchingSlots = false;
      state.error = action.payload;
    });
    // getAvailableSlots
    builder.addCase(getAvailableSlots.pending, (state) => {
      state.isFetchingAvailableSlots = true;
      state.error = "";
    });
    builder.addCase(getAvailableSlots.fulfilled, (state, action) => {
      state.isFetchingAvailableSlots = false;
      state.availableSlots = action.payload;
    });
    builder.addCase(getAvailableSlots.rejected, (state, action) => {
      state.isFetchingAvailableSlots = false;
      state.error = action.payload;
    });
  },
});

export default slotSlice.reducer;
export const { clearSlot } = slotSlice.actions;